import React , { useState , useEffect } from 'react'

import DoCase00 from './DoCase00'
import DoCase000 from './DoCase000'
import DoCase001 from './DoCase001'
import DoCase01 from './DoCase01'
import DoCase02 from './DoCase02'
import DoCase03 from './DoCase03'

//import DoCase03 from './DoCase03'

function DoCaseParse({close}) {

  const [title,setTitle] = useState( "" )
  const [cards01,setCards01] = useState([])
  const [cards02,setCards02] = useState([])
  const [cards03,setCards03] = useState([])
  const [cards04,setCards04] = useState([])
  const [cards05,setCards05] = useState( [])
  const [product,setProduct] = useState([])
  const [code,setCode] = useState( "")
  const [code2,setCode2] = useState( "" ) ;
  const [code3,setCode3] = useState( "" ) ;
  const [code4,setCode4] = useState( "" ) ;
  const [code5,setCode5] = useState( "" ) ;
  const [clean,setClean] = useState( false ) ;

  function onClean() // Se nos manda limpiar las columnas
  {
    setClean( true ) ;
  }

  useEffect(() => {

    if( clean === true )
    {
      setTimeout( theClean , 500 ) // Despues de medio segundo
    
    }

    function theClean()
    {
      console.log( "theClean") ;
      setClean( false ) ;
    }

  } , [clean])

  function setTheCode4( val )
  {
    console.log( "setTheCode4 = " + val )
    setCode4( val )
  }

  function setTheCards03( arr )
  {
    console.log( "setTheCards03 " , JSON.stringify(arr))
    setCards03( arr )
  }

  function setTheCode3( val )
  {
    console.log( "theCode3 = " + val ) ;
    setCode3( val ) ;

  }
  

  function setTheProduct( arr )
  {
    setProduct( arr ) ;

  }

  

  function setTheCards02( arr )
  {
    console.log( "setTheCards02 " , JSON.stringify(arr))
    setCards02( arr )
  }

  function theSelected( value )
  {
    console.log( "theSelected = " + value.field3 )

    setTitle( value.field3 ) ;

    console.log( "despues de field3")
  }


  function theSelected2( value )
  {
    console.log( "theSelected2 =  "  )
  }

  function setTheCards01( arr )
  {
    //setTheCards01( arr ) ;
    console.log( "setTheCards01 " , JSON.stringify(arr))
    setCards01( arr )
  }

  return (
    <div className='container my-1  w-75' >

        <div style={{display: 'inline-flex'}}>
          <p style={{fontFamily:'Satoshi-Bold' , fontSize :'20px' , color:'black'}}>Cuentas  Clave Producto Servicio </p>
          <button onClick={onClean} 
            style={{borderWidth:1,borderRadius:10,marginLeft:20,height:30}}>Clean</button>
        </div>

       <div  style={{display: 'inline-flex', overflowX: 'auto'}}>


       <div style={{ width  : '200px', paddingLeft :'0px' , paddingRight :'5px'}} >
          <div className='border rounded border-secondary' style={{borderWidth:'1px' , borderColor :'black' , borderBlockStyle :'solid' ,
                        backgroundColor :'white' , height :'80vh' }}>
              <div>
                <p>Codigo Raiz</p>
              </div>
              <DoCase00 theCards={setTheCards01} setSelected={theSelected} theCode={(val) => setCode( val )} code={code}> </DoCase00>
          </div>
        </div>


        <div style={{ width  : '300px', paddingLeft :'0px' , paddingRight :'5px'}} >
          <div className='border rounded border-secondary' style={{borderWidth:'1px' , borderColor :'black' , borderBlockStyle :'solid' ,
                        backgroundColor :'white' , height :'80vh' }}>
              <div>
                <p>Primer Nivel</p>
              </div>
              <DoCase000 theCards={setTheCards01} clean={clean} 
                setSelected={theSelected2}theCode={(val) => setCode2( val )} code={code}> </DoCase000>
          </div>
        </div>


         <div style={{ width  : '300px', paddingLeft :'0px' , paddingRight :'5px'}} >
          <div className='border rounded border-secondary' style={{borderWidth:'1px' , borderColor :'black' , borderBlockStyle :'solid' ,
                        backgroundColor :'white' , height :'80vh' }}>
              <div>
                <p>Segundo Nivel</p>
              </div>
              <DoCase001 theCards={setTheCards02} clean={clean}
                setSelected={theSelected2} code={code2}
                theCode={(val) => setTheCode3( val )} ></DoCase001>
          </div>
        </div>


       <div style={{ width  : '300px', paddingLeft :'0px' , paddingRight :'5px'}} >
          <div className='border rounded border-secondary' style={{borderWidth:'1px' , borderColor :'black' , borderBlockStyle :'solid' ,
                        backgroundColor :'white' , height :'80vh' }}>
              <div>
                <p>Tercer Nivel</p>
              </div>
              {
                cards01.length> 0 && (
                   <DoCase01 cardsPlus={cards01} clean={clean} 
                    theCards={setTheCards03} code={code3}
                    theCode={(val) => setTheCode4( val )} theProduct={setTheProduct}></DoCase01>
                )
              }
             
          </div>
        </div>


        <div style={{ width  : '300px', paddingLeft :'0px' , paddingRight :'5px'}} >
          <div className='border rounded border-secondary' style={{borderWidth:'1px' , borderColor :'black' , borderBlockStyle :'solid' ,
                        backgroundColor :'white' , height :'80vh' }}>
              <div>
                <p>Cuarto Nivel</p>
              </div>
              {
                
                cards03.length> 0 && (
                   <DoCase02 cardsPlus={cards03} theCode={(val) => setCode5( val )}
                    code={code4} clean={clean} theCards={setCards05} theProduct={setProduct} ></DoCase02>
                )
              }
             
          </div>
        </div> 


        <div style={{ width  : '300px', paddingLeft :'0px' , paddingRight :'5px'}} >
          <div className='border rounded border-secondary' style={{borderWidth:'1px' , borderColor :'black' , borderBlockStyle :'solid' ,
                        backgroundColor :'white' , height :'80vh' }}>
              <div>
                <p>Quinto Nivel</p>
              </div>
              {
             
                cards05.length> 0 && (
                    <DoCase03 cardsPlus={cards05} code={code5} clean={clean}></DoCase03>
                )
              }
             
          </div>
        </div> 


       </div> 
    </div>
  )
}

export default DoCaseParse